"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = void 0;

var styled_components_1 = __importStar(require("styled-components"));

var settings_1 = require("../../settings");

exports.Dropdown = styled_components_1.default.select(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var error = _a.error,
      disabled = _a.disabled;
  return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    border: 1px solid\n      ", ";\n    border-radius: 0;\n    padding: 1rem;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n    background-color: ", ";\n    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBhdGggZD0iTTkuMjkzIDEyLjk1bC43MDcuNzA3TDE1LjY1NyA4bC0xLjQxNC0xLjQxNEwxMCAxMC44MjggNS43NTcgNi41ODYgNC4zNDMgOHoiIC8+PC9zdmc+Cg==');\n    background-size: 24px;\n    background-repeat: no-repeat;\n    background-position: center right 1rem;\n    outline: none;\n    font-size: 1rem;\n\n    &:active,\n    &:focus {\n      border: 1px solid ", ";\n    }\n  "], ["\n    width: 100%;\n    border: 1px solid\n      ", ";\n    border-radius: 0;\n    padding: 1rem;\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n    background-color: ", ";\n    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBhdGggZD0iTTkuMjkzIDEyLjk1bC43MDcuNzA3TDE1LjY1NyA4bC0xLjQxNC0xLjQxNEwxMCAxMC44MjggNS43NTcgNi41ODYgNC4zNDMgOHoiIC8+PC9zdmc+Cg==');\n    background-size: 24px;\n    background-repeat: no-repeat;\n    background-position: center right 1rem;\n    outline: none;\n    font-size: 1rem;\n\n    &:active,\n    &:focus {\n      border: 1px solid ", ";\n    }\n  "])), error ? settings_1.settings.colours.error : settings_1.settings.colours.border, disabled ? settings_1.settings.colours.backgroundDisabled : settings_1.settings.colours.background, settings_1.settings.colours.selected);
});
var templateObject_1, templateObject_2;